<template>
    <v-card class="px-6 py-4">
        <v-card-title class="px-0">Generar Nota de Crédito</v-card-title>
        <v-card-text class="px-0">
            <v-autocomplete
                outlined
                v-model="form.company_id"
                :items="companyLists"
                :loading="isLoadingCompany"
                :search-input.sync="searchCompanies"
                :hide-no-data="searchCompanies==''||searchCompanies==undefined||searchCompanies==null"
                item-text="name"
                item-value="id"
                label="Cliente"
                placeholder="Escribe para buscar"
                attach
            >
                <template v-slot:item="{item, attrs, on}">
                    <v-list-item v-on="on" v-bind="attrs">
                        <v-list-item-content>
                            <v-list-item-title>
                                <span v-if="item.macro!=null">{{item.macro}}</span>{{item.name || item.razon_social}}
                                <div v-if="item.razon_social!=null">
                                    <span style="font-size:12px;">{{item.razon_social}}</span>
                                </div>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
                <template slot="no-data">
                    <v-row class="ma-0 py-2 px-6">
                        <span>No existen clientes relacionados.</span>
                    </v-row>
                </template>
            </v-autocomplete>

            <v-row class="ma-0">
                <v-col cols="6" class="pl-0">
                    <v-menu v-model="datePicker" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field outlined v-model="form.date" label="Fecha" prepend-inner-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker color="primary" v-model="form.date" @input="datePicker = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="6" class="pr-0">
                    <v-text-field
                        outlined
                        type="number"
                        min="0"
                        v-model="form.amount"
                        label="Monto total con IVA incluido"
                    ></v-text-field>
                </v-col>
            </v-row>

            <v-text-field outlined v-model="form.description" label="Descripción"></v-text-field>

            <v-row class="ma-0">
                <v-col cols="6" class="pl-0">
                    <v-autocomplete
                        v-model="form.payment_form"
                        :items="payment_forms"
                        item-text="text"
                        item-value="value"
                        outlined
                        label="Forma de Pago"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="6" class="pr-0">
                    <v-autocomplete
                        v-model="form.use"
                        :items="cfdiLists"
                        item-text="Descripción"
                        item-value="Clave"
                        outlined
                        label="Uso de CFDI"
                    ></v-autocomplete>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions class="px-0">
            <v-spacer></v-spacer>
            <v-btn text @click="close(false)">Cancelar</v-btn>
            <v-btn color="primary" class="elevation-0" :loading="isSaving" :disabled="disabled" @click="generateCreditNote">
                Generar Nota de Crédito
            </v-btn>
        </v-card-actions>

        <v-snackbar :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.message }}
        </v-snackbar>
    </v-card>
</template>

<script>
import axios from "axios"
import fiscal_catalogs from '../../mixins/fiscal_catalogs'

export default {
    mixins: [fiscal_catalogs],
    data: () => ({
        datePicker:false,
        isSaving:false,
        isLoadingCompany:false,
        searchCompanies:null,
        entries:{
            companies:[]
        },
        form:{
            company_id:undefined,
            date:new Date().toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).toString().slice(0, 10),
            amount:null,
            description:'Nota de crédito',
            payment_form:'03',
            use:'G02',
            idempotency_key:null,
        },
        snackbar:{
            show:false,
            message:null,
            color:null
        }
    }),
    computed:{
        companyLists(){
            return this.entries.companies.map(company => {
                return {
                    id:company.id,
                    macro:company.attributes.macro,
                    name:company.attributes.name,
                    razon_social:company.attributes.razon_social,
                    facturapi_id:company.attributes.facturapi_id
                }
            })
        },
        cfdiLists(){
            return this.$store.state.cfdi.uses
        },
        disabled(){
            return this.isSaving ||
                !this.form.company_id ||
                !this.form.amount ||
                Number(this.form.amount) <= 0 ||
                !this.form.payment_form ||
                !this.form.use
        }
    },
    methods:{
        close(refresh){
            this.$emit("closeStandaloneCreditNoteDialog", refresh)
        },
        generateCreditNote(){
            this.isSaving = true
            const payload = {
                ...this.form,
                amount: Number(this.form.amount),
                idempotency_key: this.form.idempotency_key || 'standalone-credit-note-' + Date.now()
            }

            axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/facturapi/credit-notes", payload).then(() => {
                this.close(true)
            }).catch(error => {
                this.snackbar = {
                    message: error.response?.data?.message || 'Error al generar la nota de crédito.',
                    color: 'error',
                    show: true
                }
                this.isSaving = false
            })
        }
    },
    watch:{
        searchCompanies(val){
            if(val!=undefined&&val!=null){
                if (this.isLoadingCompany) return
                this.isLoadingCompany = true
                axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/companies?filter[name_razon_social]='+val)
                .then(res => {
                    this.entries.companies = res.data.data
                }).finally(() => (this.isLoadingCompany = false))
            }
        }
    }
}
</script>
